import React, { useState, useEffect, useRef } from 'react'
import { useNavigate, Link } from 'react-router-dom'

import { logout } from 'util/api'
import { getCache } from 'util/cache'

import 'css/components/navbar.css'
import bars from 'img/bars-white.svg'
import logo from 'img/logo_main-cropped.svg'
import person from 'img/person.svg'

export const Navbar = () => {
	const navigate = useNavigate()
	const loggedIn = localStorage.getItem('loggedIn')

	const menuButton = useRef(null)
	const navItems = useRef(null)

	const [expand, setExpand] = useState(false)
	const [profilePic, setProfilePic] = useState(getCache('profilePicture') || person)

	useEffect(() => {
		const handleProfilePicUpdated = () => {
			setProfilePic(getCache('profilePicture') || person)
		}
		window.addEventListener('afo:profilePicUpdated', handleProfilePicUpdated)
		return () => window.removeEventListener('afo:profilePicUpdated', handleProfilePicUpdated)
	}, [])

	const handleLogout = async () => {
		setExpand(false)
		await logout()
		localStorage.removeItem('loggedIn')
		localStorage.removeItem('profilePicture')
		localStorage.removeItem('firstName')
		navigate('/login')
	}


	useEffect(() => {
		function handleClickOutside(event) {
			const buttonEl = menuButton.current
			const itemsEl = navItems.current

			if (!buttonEl && !itemsEl) return

			const clickOnButton = buttonEl && buttonEl.contains(event.target)
			const clickOnItems = itemsEl && itemsEl.contains(event.target)

			if (clickOnButton || clickOnItems) return

			setExpand(false)
		}

		document.addEventListener('mousedown', handleClickOutside)
		return () => document.removeEventListener('mousedown', handleClickOutside)
	}, [])

	return (
		<nav className={"navbar " + (loggedIn ? "logged-in" : "")}>
			<Link to="/dashboard">
				<img className="logo" src={logo} />
			</Link>
			<div className="nav-right">
				{loggedIn && (
					<>
						<Link to="/classrooms" onClick={() => setExpand(false)}>My Classrooms</Link>
						<Link to="/upload-lessons" onClick={() => setExpand(false)}>Plan New Lesson</Link>
						<Link to="/lessons" onClick={() => setExpand(false)}>Library</Link>
					</>
				)}

				<div
					className="dropdown-button"
					ref={menuButton}
					onClick={() => setExpand(!expand)}
				>
					<img className="bars" src={bars} />
					<img
						className="profile-pic"
						src={profilePic}
					/>
				</div>
				<div className={"nav-items " + (expand ? "" : "hidden")} ref={navItems}>
					{!loggedIn ? (
						<>
							<Link
								className="signup"
								to="/signup"
								onClick={() => setExpand(false)}
							>
								Sign up
							</Link>
							<Link
								className="login"
								to="/login"
								onClick={() => setExpand(false)}
							>
								Log in
							</Link>
						</>
					) : (
						<>
							<Link
								className="settings"
								to="/settings"
								onClick={() => setExpand(false)}
							>
								Settings
							</Link>
							<Link
								className="dashboard"
								to="/dashboard"
								onClick={() => setExpand(false)}
							>
								Dashboard
							</Link>
							<Link
								className="logout"
								onClick={handleLogout}
							>
								Log out
							</Link>
						</>
					)}
				</div>
			</div>
		</nav>
	)
}
